module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-money-77c8e842b8e05f354b7f4205009e7ba6.svg";